import { render } from "./VuesaxLinearBrifecaseTick.vue?vue&type=template&id=d3d12182"
import script from "./VuesaxLinearBrifecaseTick.vue?vue&type=script&lang=js"
export * from "./VuesaxLinearBrifecaseTick.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__